var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12594",
    "data-name": "Group 12594",
    transform: "translate(-22754 472)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(22754 -472)",
    fill: "rgba(215,25,32,0.22)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(22755.996 -465.008)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 22.609,
    cy: 22.609,
    r: 22.609,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 12.029, 39.009)",
    fill: "#f47a65"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 15.073,
    cy: 15.073,
    r: 15.073,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 22.688, 39.008)",
    fill: "#ef998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M57.806,18.179a24.495,24.495,0,1,0,0,34.64A24.335,24.335,0,0,0,57.806,18.179ZM55.142,50.152a20.726,20.726,0,1,1,0-29.311,20.584,20.584,0,0,1,0,29.311Z",
    transform: "translate(3.517 3.511)",
    fill: "#444a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M42.982,19.291a1.882,1.882,0,0,0-2.664,0l-6.66,6.662L27,19.291a1.884,1.884,0,0,0-2.664,2.664l6.66,6.662-6.66,6.662A1.884,1.884,0,0,0,27,37.944l6.66-6.662,6.66,6.662a1.884,1.884,0,1,0,2.664-2.664l-6.66-6.662,6.66-6.662A1.884,1.884,0,0,0,42.982,19.291Z",
    transform: "translate(10.39 10.349)",
    fill: "#444a54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailIcon);
export default __webpack_public_path__ + "static/media/PaymentFailIcon.29a822a6e74108243d087c6c842dca94.svg";
export { ForwardRef as ReactComponent };